<template>
  <main :class="['gameplay', {magic_question: isCurrentRoundMagicQuestion}]">
    <game-header :question-steps="questionSteps" :current-question-index="currentQuestionIndex">
      <template slot="timer">
        <timer ref="timerRef" @time:expired="handleTimeExpired"></timer>
      </template>
    </game-header>

    <game-main
      :question="currentRoundInfo.question"
      :answers="currentRoundInfo.answers"
      :validating-answer="validatingAnswer"
      @answer:selected="handleAnswerSelected"
    ></game-main>
  </main>
</template>

<script>
import {mapMutations, mapState} from 'vuex'
import {Howl} from 'howler'
import GameHeader from './GameHeader'
import GameMain from './GameMain'
import Timer from './Timer'
import {apiResponseTypeEnum} from '../../../constants/api'

const answerChoiceByIndex = {0: 'A', 1: 'B', 2: 'C', 3: 'D'}

export default {
  name: 'DistinguishedGame',
  emits: ['game:over'],
  components: {
    GameHeader,
    GameMain,
    Timer
  },
  data () {
    return {
      sounds: {
        correctAnswer: new Howl({src: ['/static/sounds/right.mp3']}),
        wrongAnswer: new Howl({src: ['/static/sounds/wrong.wav']})
      },
      currentQuestionIndex: 0,
      questionResultDelay: 1500,
      validatingAnswer: false
    }
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex'
    ]),
    ...mapState('game', [
      'gameID',
      'miniGames'
    ]),
    questionSteps () {
      return this.miniGames.map(({id, answered, correct}, index) => ({miniGameId: id, answered, correct, index}))
    },
    currentRoundInfo () {
      const data = this.miniGames[this.currentQuestionIndex]

      if (!data) { return {} }

      const constructQuestion = ({id, question, img, magicQuestion, answered, correct, correctPoints, wrongPoints, userAnswerInfo}) =>
        ({miniGameId: id, text: question, imgSrc: img, magicQuestion, answered, correct, correctPoints, wrongPoints, userAnswerInfo})

      const constructAnswers = ({answers}) => {
        if (!Array.isArray(answers)) { return [] }

        return answers.map((answer, index) => ({text: answer, choice: answerChoiceByIndex[index]}))
      }

      return {question: constructQuestion(data), answers: constructAnswers(data)}
    },
    isCurrentRoundMagicQuestion () {
      return !!this.currentRoundInfo.question && this.currentRoundInfo.question.magicQuestion
    }
  },
  methods: {
    ...mapMutations('game', [
      'setMiniGameAnswer'
    ]),
    stopTimer () {
      if (this.$refs.timerRef) {
        this.$refs.timerRef.stopTimer()
      }
    },
    emitGameOver ({gameCompleted = false} = {}) {
      this.$emit('game:over', {gameCompleted})
    },
    handleTimeExpired () {
      this.emitGameOver()
    },
    async handleAnswerSelected ({miniGameId, answerInfo}) {
      this.validatingAnswer = true

      if (this.currentQuestionIndex === this.miniGames.length - 1) {
        this.stopTimer()
      }

      try {
        const response = await this.$axios({
          url: `api/sendAnswerDistinguished`,
          method: 'GET',
          headers: {Authorization: this.jwtInVuex},
          params: {
            gameId: this.gameID,
            miniGameId,
            answer: answerInfo.text
          }
        })

        const {responseEnum, data: responseData} = response.data

        if (responseEnum === apiResponseTypeEnum.OPERATION_SUCCESS) {
          if (['CORRECT_ANSWER', 'WRONG_ANSWER'].includes(responseData.status)) {
            this.setMiniGameAnswer({
              index: this.currentQuestionIndex,
              data: {
                correct: responseData.status === 'CORRECT_ANSWER',
                userAnswerInfo: {text: answerInfo.text, choice: answerInfo.choice},
                answered: true
              }
            })

            if (localStorage.getItem('soundsOn') === 'true') {
              if (this.miniGames[this.currentQuestionIndex].correct) {
                this.sounds.correctAnswer.play()
              } else {
                this.sounds.wrongAnswer.play()
              }
            }
          }
        }
      } catch (_e) {
      }

      setTimeout(() => {
        this.validatingAnswer = false

        if (this.currentQuestionIndex < this.miniGames.length - 1) {
          ++this.currentQuestionIndex
        } else {
          this.emitGameOver({gameCompleted: true})
        }
      }, this.questionResultDelay)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/game/DistinguishedGame.vue